export default {
  GET_COMPLETED_RESERVE_REPORT: 'GET_COMPLETED_RESERVE_REPORT',
  GET_COMPLETED_RESERVE_REPORT_LOADING: 'GET_COMPLETED_RESERVE_REPORT_LOADING',
  GET_COMPLETED_RESERVE_REPORT_SUCCESS: 'GET_COMPLETED_RESERVE_REPORT_SUCCESS',
  GET_COMPLETED_RESERVE_REPORT_FAILED: 'GET_COMPLETED_RESERVE_REPORT_FAILED',
  GET_COMPLETED_RESERVE_REPORT_REJECT: 'GET_COMPLETED_RESERVE_REPORT_REJECT',
};
